import Vue from "vue";
import Vuex from "vuex";

// STORAGE OPERATIONS
import {
  storage,
  setToLocalStorage,
  toDateNoTimezone,
  fetchCountryName,
  fetchContent,
  createToken
} from "@/utils";

// TEMP FROM CLIENT
// import { countrylist } from "./countrylist";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    response_country:'',
    minisite_data:null,
    minisite_dic:null,
    minisite_VisibleSection:0,
    xSelectedPlatform:0,
    
    // defaultItemBg: '@/assets/img/ImageNot.svg',
    /*
      Homepage has been visited
    */
    dirtyHome: false,
    pageReady: false,
    pageCid: null,
    rawitems: null,
    product_data:null,
    catalog_index:null,
    menuItems: [],
    searchResults: null,
    sitemap: null,
    /*
      >> SEARCH >>
    */
    popularSearches: {
      timestamp: null,
      list: []
    },
    recentSearches: [],
    /*
      << SEARCH <<
    */

    overlay: {
      active: false,
      type: "overlay-menu"
    },
    popup: {
      active: false,
      css: null,
      title: null,
      content: "",
      image: null
    },
    callbacks: {
      myCbFunction() {
        alert("callback function YAY!");

      }
    },
    dimensions: {
      width: window.innerWidth,
      height: window.innerHeight
    },
    pageLayoutData: null,

    /*
        countries list and 
        search for country autocomplete
    */
    countries: null,
    search: "",
    /*
      Abstraction of the open panels in
      PanelGroup for the purpose of
      manipulating the panels from other
      components (mainly from contact page)
    */
    openPanels: [],
    /*
        Set filter for filter panel
    */
    filtersHash: [],

    /*

        Global tracking of Overlay Gallery
    */
    gallery: {
      index: -1,
      children: []
    },

    /*
        Common access to Events data
    */
    events: {
      list: [],
      filters: [
        {
          id: 1,
          prop: "event_country_code",
          title: "Location",
          list: []
        }
      ],
      // Used for v-calendar attributes
      attributes: []
    },
    /*
        Common access to date picker
        selected dates.
    */
    date: {
      start: null,
      end: null
    },
    localeRx: /^\w{2}-\w{2}$/,
    locale: {
      ln: "",
      cc: "",
      name: "Global"
    },
    /*
        Dictionary of key/value pairs
        for UI static text.
    */
    localizedUI: {},
    localizedUIReady: false,

    collections: {
      activeitem: -1,
      activeCollection:-1,
      children: [],
      activeCollectionItems:[],
      viewCollections:false
    },
    //collectionsList:[],
    //itemToCollect:-1,
    //activeCollectionID:null,    

    auid:null 

    /* Collections 
      itemToCollect: when user clicks on (+) to collect item
      activeCollectionID : last collection id used
    */ 

  },
  mutations: {
    SET_PLATFORM(state,index)
    {
      state.xSelectedPlatform = index;
    },
    SET_HP_CONTENT(state)
    {

    },
    SET_MS_DATA(state, data)
    {
      state.minisite_data = data;
    },
    SET_MS_DIC(state, data)
    {
      state.minisite_dic = data;
    },
    OPEN_COLLECTIONS_VIEW(state)
    {
      state.collections.viewCollections = true;
    },
    CLOSE_COLLECTIONS_VIEW(state)
    {
      state.collections.viewCollections = false;
    },
    SET_COLLECTIONS(state,collections){
      state.collections.children = collections;
    },
    SET_AUID(state) 
    {
      let AUID = storage.get(`MIS-AUID`, localStorage);
      if (AUID) {
        console.log("[SET_AUID] auid found in localStorage: "+AUID);
      }else{        
        AUID = createToken(32);
        console.log("[SET_AUID] NEW AUID: "+AUID);
      }
      setToLocalStorage(`MIS-AUID`,AUID);//<<<<<not working, need to save to localStorage
      state.auid = AUID;

      //READ COLLECTIONS LIST TO THE STORE
    },
    SET_COLLECT_ITEM(state, itemid)
    {
      console.log('itemid >> ', itemid);
        state.collections.activeitem = itemid;
    },
    SET_ACTIVE_COLLECTION(state, collectionID)
    {
      state.collections.activeCollection = collectionID;
    },
    SET_PAGEREADY(state, bool) {
      state.pageReady = bool;
    },
    SET_PAGE_CID(state, cid) {
      state.pageCid = cid;
    },
    DIRTIFY_HOME(state, bool) {
      state.dirtyHome = bool;
    },
    SET_COUNTRY(state, country) {
      state.response_country = country;
    },
    SET_LOCALE(state, locale) {
      if (locale && state.localeRx.test(locale)) {
        let l = locale.split("-");
        state.locale.ln = l[0];
        state.locale.cc = l[1];
        state.locale.name = fetchCountryName(state.locale.cc);
      } else {
        state.locale.ln = "en";
        state.locale.cc = "";
        state.locale.name = "Global";
      }
    },
    SET_LOCALIZED_UI(state, dict) {
      state.localizedUI = dict;
      state.localizedUIReady = true;
    },
    UNSET_LOCALIZED_UI(state) {
      state.localizedUIReady = false;
    },
    SET_RAW_ITEMS(state, items) {
      state.rawitems = items;
    },
    SET_PRODUCT(state, pro_data) {      
      state.product_data = pro_data;
    },
    SET_CATALOGINDEX(state, index) {
      state.catalog_index = index;
    },
    SET_SITEMAP(state, map) {
      state.sitemap = map;
    },
    SET_DIMENSIONS(state, dimensions) {
      state.dimensions = dimensions;
    },
    TOGGLE_POPUP(state, bool) {
      console.log("TOGGLE POPUP ", bool);
      // if (!bool) {
      //   state.popup = {
      //     css: null,
      //     title: null,
      //     content: ""
      //   };
      // }
      state.popup.active = bool;
    },
    UPDATE_POPUP(state, popdata) {
      let _d = _.pick(popdata, [
        "title",
        "image",
        "sub_title",
        "content",
        "summary"
      ]);
      _d.active = true;
      state.popup = _d;
      console.log("2 update popup > ", state.popup);
    },
    UPDATE_POPULAR_SEARCHES(state, payload) {
      state.popularSearches = payload;
    },
    UPDATE_RECENT_SEARCHES(state, list) {
      state.recentSearches = list;
    },
    TOGGLE_OVERLAY(state, payload) {
      state.overlay.active = payload.active; //typeof bool === "boolean" ? bool : !state.overlay.active;
      state.overlay.type = payload.type;
    },
    UPDATE_GALLERY_INDEX(state, index) {
      state.gallery.index = index;
    },
    UPDATE_GALLERY_CHILDREN(state, children) {
      if (children && children.length) {
        state.gallery.children.push(...children);
        // state.gallery.children = _.uniqBy(state.gallery.children, "url");
      } else {
        state.gallery.children = [];
      }
    },
    SET_MENU(state, payload) {
      state.menuItems = payload;
    },
    SET_PAGE_LAYOUT(state, data) {
      ///alert("xxxx - setting page layout:"+data.length);
      state.pageLayoutData = data;
    },
    SET_COUNTRIES(state, countries) {
      state.countries = countries;
    },
    UPDATE_SEARCH(state, search) {
      state.search = search;
    },
    UPDATE_PANELS(state, panels) {
      state.openPanels = panels;
    },
    UPDATE_FILTERS_HASH(state, filters) {
      state.filtersHash = filters;
    },
    SET_EVENTS(state, events) {
      state.events.list = events;
    },
    SET_EVENTS_FILTER(state, filters) {
      state.events.filters = filters;
    },
    INIT_EVENTS_FILTER(state, locations) {
      state.events.filters[0].list = _.sortBy(locations, "label");
    },
    SET_DATE(state, date) {
      state.date = date;
    },
    SET_CALENDAR_ATTRIBUTES(state, attr) {
      state.events.attributes = attr;
    },
    SET_ACTIVE_COL_ITEMS(state,items)
    {
      state.collections.activeCollectionItems = items;
    }
  },
  /* *********************** ACTIONS  *********************** */
  actions: {
    xSetPlatform({state,commit,dispatch},index)
    {
        commit('SET_PLATFORM',index);
    },
    addItemToCollection({state,commit,dispatch},ProductID)
    {
      var CollectionName = "Default";
      var apiURL = "https://api.mis-implants.com/api/collections?AUID="+state.auid+"&Name="+CollectionName+"&ItemID="+ProductID;
      fetch(apiURL, {
        method: "POST",
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {"Content-Type": "application/json;charset=UTF-8",'Access-Control-Allow-Origin': '*'},
        referrerPolicy: "no-referrer", // no-referrer, *client
        body: ""
      })
      .then(function(response) { return response.json();})
      .then(function(response){dispatch('updateStoreCollection');});
    },
    updateStoreCollection({state,commit})
    {
      //READ THE DEFAULT COLLECTION AND UPDATE THE ARRAY
      if(state.auid!=null)
      {
        var apiURL = "https://api.mis-implants.com/api/collections?AUID="+state.auid+"&mode=ids";
        fetch(apiURL,{method: 'GET',mode: 'cors',cache: 'no-cache',headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'}})
        .then(function(response){return response.json();})
        .then(function(response){commit("SET_ACTIVE_COL_ITEMS",response);});         
      }
    },
    closeCollectionsViewer({commit})
    {
      commit("CLOSE_COLLECTIONS_VIEW");
    },
    showCollectionsViewer({commit})
    {
      commit("OPEN_COLLECTIONS_VIEW");
    },

    

    setItemToCollect({ commit },itemid) { 
      //console.log('ACTION itemid > ', itemid)
      commit("SET_COLLECT_ITEM",itemid);
    },
    setActiveCollection({ commit },collectionID) {
      commit("SET_ACTIVE_COLLECTION",collectionID);
    },
    setCollectionsList({ commit },collectionsList) {
      commit("SET_COLLECTIONS",collectionsList);
    },

    initAUID({ commit }) {
      commit("SET_AUID");
    },
    async initCollectionsList({ state,commit }) 
    {
      //https://api.mis-implants.com/api/collections?auid=e7RzYBEXFYBi8NcFGtOdzWYZ6Yh3SeXY
      //alert("init collections list");//alert("auid="+state.auid);
      commit("SET_AUID");//verify the AUID before getting the collections           
      let vm = this._vm;
      let content = await fetchContent("g","collections",vm,state,commit,"SET_COLLECTIONS",`https://api.mis-implants.com/api/Collections?AUID=${state.auid}`);
      return content;
    },    
    async initHomepageData({ state,commit }, path) 
    {
      let vm = this._vm;
      if (path.indexOf("/") === 0) {path = path.substr(1);}      
      let body = JSON.stringify({ path });
      let apiHeaders = { "Content-Type": "application/json" };
      let apiOptions = { body, method: "post" };
      let mutation = "SET_HP_CONTENT";


      let content = await fetchContent(
        path,
        "pageByPath",
        vm,
        state,
        commit,
        mutation,
        `https://api.mis-implants.com/api/pagebypath`,
        apiHeaders,
        apiOptions
      );
      return content;
    },        
    setPageReady({ commit }, bool) {
      commit("SET_PAGEREADY", bool);
    },
    setMinisiteData({ commit }, data) {
      commit("SET_MS_DATA", data);
    },
    setMinisiteDic({ commit }, data) {
      commit("SET_MS_DIC", data);
    },

    setPageCid({ commit }, cid) {
      commit("SET_PAGE_CID", cid);
    },
    dirtifyHome({ commit }, bool) {
      commit("DIRTIFY_HOME", bool);
    },
    /*
      Window Resize Handler,
      commit window dimensions
      for app wide use (js UI responsiveness)
    */
    setDimensions({ commit }) {
      let dimensions = {
        width: window.innerWidth,
        height: window.innerHeight
      };
      // console.log("set dimensions >> ", dimensions);
      commit("SET_DIMENSIONS", dimensions);
    },

    /*
      Initialize localization parameters for App.
    */
    setCountry({ commit }, cc) {
      commit("SET_COUNTRY", cc);
    },  
    setLocale({ commit }, locale) {
      commit("SET_LOCALE", locale);
    },
    updateFiltersHash({ commit }, filters) {
      commit("UPDATE_FILTERS_HASH", filters);
    },
    updateDate({ commit }, date) {
      commit("SET_DATE", date);
    },

    /*
      POPUP
    */
    togglePopup({ commit }, bool) {
      commit("TOGGLE_POPUP", bool);
    },
    updatePopup({ commit }, popdata) {
      console.log("UPDATE POPUP > ", popdata);
      commit("UPDATE_POPUP", popdata);
    },

    /*
      Set index for global overlay gallery,
      this will also toggle the gallery if
      index > -1 or not.
    */
    setGalleryIndex({ commit }, index) {
      commit("UPDATE_GALLERY_INDEX", index);
    },
    setGalleryChildren({ commit }, children) {
      commit("UPDATE_GALLERY_CHILDREN", children);
    },
    /*
      Update Search state
    */
    updatePopularSearches({ commit }, payload) {
      /*
        payload will either be the full object (from storage)
        e.g { list: ['','',''...], timestamp: date }
        or just the list, e.g ['','',''...]
      */
      let timestamp = payload.timestamp || new Date(),
        list = payload.list || payload;
      commit("UPDATE_POPULAR_SEARCHES", { timestamp, list });
    },
    updateRecentSearches({ commit }, list) {
      commit("UPDATE_RECENT_SEARCHES", list);
    },
    /*
      Toggle the blue overlay menu
      from hamburger menu icon
    */
    toggleOverlay({ state, commit }, payload) {
      // console.log("toggle menu...", bool);
      let active =
          typeof payload === "boolean"
            ? payload
            : payload.active || !state.overlay.active,
        type = payload.type || "overlay-menu";
      // if (state.overlay.active !== active) {
      commit("TOGGLE_OVERLAY", { active, type });
      // }
    },
    setDateToStore({ commit }, date) {
      commit("SET_DATE", date);
    },
    setEvents({ commit, dispatch }, events) {
      dispatch("initEventsFilter", events);

      commit("SET_EVENTS", events);
    },
    initEventsFilter({ commit }, events) {
      let locations = _.compact(
        events.map(event => event.event_properties.event_country_code)
      );
      commit(
        "INIT_EVENTS_FILTER",
        locations.map(loc => {
          return { label: loc, active: false };
        })
      );
    },
    setEventsFilter({ commit }, filters) {
      commit("SET_EVENTS_FILTER", filters);
    },
    setCalendarAttributes({ commit }, attr) {
      commit("SET_CALENDAR_ATTRIBUTES", attr);
    },
    async initLocalizedUI({ state, commit }) {
      commit("UNSET_LOCALIZED_UI");
      let vm = this._vm;
      let ln = state.locale.ln;
      let content = await fetchContent("g","pageUi_V2",
        vm,state,commit,
        "SET_LOCALIZED_UI",
        `https://api.mis-implants.com/api/pageUi?ln=${ln}`
      );
      return content;
    },
    /*
      FETCH product info from server
    */
      async initProductData({ state, commit, dispatch }) {
        let vm = this._vm;
        let content = await fetchContent(
          "g",
          "product",
          vm,
          state,
          commit,
          "SET_PRODUCT",
          "https://api.mis-implants.com/api/pagebypath",
        );
        //dispatch("initMenu");
        //alert("content="+content);
        return content;
      },    
    /*
      FETCH raw site items json from server
    */
    async initRawItems({ state, commit, dispatch }) {
      let vm = this._vm;
      let content = await fetchContent(
        "g",
        "rawitems",
        vm,
        state,
        commit,
        "SET_RAW_ITEMS",
        "https://api.mis-implants.com/api/sitenav/-4"
      );
      dispatch("initMenu");
      return content;
    },
    /*
      FETCH raw menu json from server
    */
    async initMenu({ state, commit }) {
      let vm = this._vm;
      let content = await fetchContent(
        "g",
        "menu",
        vm,
        state,
        commit,
        "SET_MENU"
      );
      if (content.noData) {
        let items = state.rawitems;
        let parsedMenu = parseMenu(items);
        content.useCache &&
          storage.set(content.storageKey, JSON.stringify(parsedMenu));
        commit("SET_MENU", parsedMenu);
        return parsedMenu;
      }
    },
    resetPageLayout({ commit }) {
      commit("SET_PAGE_LAYOUT", null);
    },
    /*
      Init Route Data by CID (Category ID)
    */
    async initRouteByCid({ dispatch, commit, state }, cid) {
      dispatch("setPageReady", false);
      if (cid === 404) {
        commit("SET_PAGE_LAYOUT", 404);
        return 404;
      }
      let vm = this._vm;
      let mutation = "SET_PAGE_LAYOUT";
      console.log("initRouteByCid");

      

      let content = await fetchContent(
        cid,
        "pageByCid",
        vm,
        state,
        commit,
        mutation,
        `https://api.mis-implants.com/api/page/${cid}`
      );
      dispatch("setPageReady", true);
      dispatch("setPageCid", cid);
      return content;
    },

    /*
      Init Route Data by path name
      * If no CID is found
      * Mostly for Blog Articles, etc...
    */
    async initRouteByPath({ commit, state }, name) {
      //alert("name="+name);

      if (name.indexOf("/") === 0) {
        name = name.substr(1);
      }
      let vm = this._vm;
      let body = JSON.stringify({ name });
      let apiHeaders = { "Content-Type": "application/json" };
      let apiOptions = { body, method: "post" };
      let mutation = "SET_PAGE_LAYOUT";
      console.log("pAGE BY PATH! >> ", name);
      let content = await fetchContent(
        name,
        "pageByPath",
        vm,
        state,
        commit,
        mutation,
        `https://api.mis-implants.com/api/pagebypath`,
        apiHeaders,
        apiOptions
      );
      console.log("pAGE BY PATH! >> ", content);

      return content;
    },
    /*
      set countries data for contact page
    */
    setCountries({ commit }, countries) {
      countries = _.filter(countries, "latlng");
      countries.forEach(country => {
        country.latlng = country.latlng.map(parseFloat);
      });
      console.log("set countries ", _.filter(countries, "latlng"));
      commit("SET_COUNTRIES", countries);
    }
  },
  getters: {
    getAUID(state)
    {
      return state.auid;
    },  
    getItemToCollect(state)
    {
      return state.collections.activeitem;
    },  
    localeString(state) {
      // console.log("default lanng > ", Vue.$defaultLang);
      if (state.locale.cc) {
        return state.locale.ln + "-" + state.locale.cc;
      }
      // else if (state.locale.ln !== "en") {
      return state.locale.ln;
      // }
      // return "";
    },
    localePath(state) {
      if (state.locale.cc) {
        return state.locale.ln + "-" + state.locale.cc;
      }
      return "";
    },
    rootCategories(state) {
      return state.menuItems[0];
    },
    catalogCategories(state) {
      let items = state.menuItems;
      // let menu = state.overlay;
      if (items.length) {
        // console.log("menu > ", menu);?
        let catalog = _.find(items, { cid: 3382 }),
          cats = catalog.children;

        if (cats) {
          cats.forEach(cat => {
            cat.icon = `/img/icons/${cat.url_part}.svg`;
          });
        }
        // console.log("GETTERS)) catalog > ", cats);
        return cats;
      }
      return [];
    },
    filteredEvents(state) {
      let events = state.events,
        date = state.date;
      if (events.list) {
        if (events.filters) {
          let _f = events.filters;
          return events.list.filter(event => {
            var pass = true,
              _props = event.event_properties;
            _f.forEach(filter => {
              let prop = filter.prop;
              let list = filter.list.filter(item => item.active);
              if (list.length) {
                list = _.map(list, "label");
                pass = _props[prop] ? list.indexOf(_props[prop]) > -1 : false;
              }
            });

            if (pass) {
              let eventStart = toDateNoTimezone(_props.event_start_date),
                eventEnd = toDateNoTimezone(_props.event_end_date),
                startDate_filter = _.isDate(date.start)
                  ? toDateNoTimezone(date.start)
                  : null,
                endDate_filter = _.isDate(date.end)
                  ? toDateNoTimezone(date.end)
                  : null;
              if (startDate_filter && !endDate_filter) {
                pass =
                  _props.event_start_date && eventStart === startDate_filter;
              } else if (startDate_filter && endDate_filter) {
                pass =
                  (_props.event_start_date &&
                    (eventStart >= startDate_filter &&
                      (eventStart <= endDate_filter ||
                        (eventEnd && eventEnd <= endDate_filter)))) ||
                  (eventEnd &&
                    (eventEnd <= endDate_filter &&
                      eventEnd >= startDate_filter));
              }
            }
            return pass;
          });
        }
      }
    }
  }
});

const parseMenu = function(items) {
  let itemsByHierarchy = items.filter(t => t.level == 0);
  _.each(itemsByHierarchy, item => {
    item.children = items.filter(t => t.pid == item.cid);
    _.each(item.children, item => {
      item.children = items.filter(t => t.pid == item.cid);
      _.each(item.children, item => {
        item.children = items.filter(t => t.pid == item.cid);
      });
    });
  });
  // console.log("parsed menu >> ", itemsByHierarchy);
  return itemsByHierarchy;
};
